module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/artillery-strike-reward-50.8403d671.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/artillery-strike-reward-50.png
// module id = 3777
// module chunks = 11